import {Modal} from "react-bootstrap";
import {useState} from "react";
import {FormattedMessage, useIntl} from "react-intl";
import {NonComplianceForm} from "./NonComplianceForm";

export function AddNonComplianceModal({show, setShow, candidature, nonComplianceCauseToRegulationMap, onSubmitCallback}) {
    const intl = useIntl();
    const [error, setError] = useState(null);
    const [entity, setEntity] = useState(null);

    async function onSubmit() {
        try {
            setShow(false);
            onSubmitCallback?.()
        } catch (error) {
            setError(error);
        }
    }

    function handleClose() {
        setShow(false);
    }

    return (
        <Modal show={show} onHide={handleClose} dialogClassName='modal-65'>
            <Modal.Header closeButton>
                <Modal.Title><FormattedMessage id='candidatureTabs.oversight.tabs.noncompliance.add' /></Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <NonComplianceForm
                    candidatureExternalId={candidature.externalId}
                    nonComplianceCauseToRegulationMap={nonComplianceCauseToRegulationMap}
                    onSubmitCallback={onSubmit}
                    onCancel={handleClose}
                />
            </Modal.Body>
        </Modal>

    );
}
